<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Copy" });
import Icon from "../icon/Icon.svelte";
import { addMessage } from "../../stores/messages.js";
export let text;
export let css = "";
const copyClipboard = async () => {
    addMessage({ heading: "Copied to Clipboard", type: "info" });
    await navigator.clipboard.writeText(text);
};
</script>

<Icon
    key = 'copy'
    on:click = { copyClipboard }
    css = { `${ css } h-3.5 cursor-pointer stroke-grey !inline-block` }
/>